.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 400px;
  background-color: #1c1c1c;
  border-right: 1px solid #1c1c1c;
  display: flex;
  flex-direction: column;
  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.3);
}

.sidebar.collapsed {
  width: 70px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem 0.75rem;
  margin: 0 0.25rem;
  border-bottom: 1px solid #1c1c1c;
  min-height: 40px;
  background: #1c1c1c;
  position: relative;
  gap: 0.75rem;
}

.sidebar.collapsed .header {
  justify-content: flex-start;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
}

.logoContainer {
  display: flex;
  align-items: center;
  overflow: hidden;
  max-width: 100%;
}

.logo {
  height: 40px;
  transition: opacity 0.2s ease;
}

.sidebar.collapsed .logo {
  opacity: 0;
  pointer-events: none;
}

.sidebar.collapsed .logoContainer {
  width: 0;
  overflow: hidden;
}

.sidebarToggle {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  text-decoration: none;
  color: #e9fff9;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 4px;
  position: relative;
  font-size: 0.875rem;
  font-weight: 500;
  overflow: hidden;
  min-width: 2rem;
  min-height: 2rem;
  width: 2rem;
  height: 2rem;
}

.sidebarToggle:hover .iconContainer {
  background-color: rgba(12, 12, 12, 0.6);
  border-radius: 4px;
  padding: 3px;
  margin: -3px;
}

.sidebarToggle .icon {
  width: 1.5rem !important;
  height: 1.5rem !important;
  font-size: 1.5rem !important;
}

.navigation {
  flex: 1;
  padding: 0.5rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.navItem {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  margin: 0 0.25rem;
  border-radius: 6px;
  text-decoration: none;
  color: #e9fff9;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  font-size: 0.875rem;
  font-weight: 500;
  overflow: hidden;
  min-height: 2rem;
}

.navItem:hover {
  color: #e9fff9;
  text-decoration: none;
}

.navItem:hover .iconContainer {
  background-color: rgba(12, 12, 12, 0.6);
  border-radius: 4px;
  padding: 3px;
  margin: -3px;
}

.iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
}

.icon {
  width: 2rem;
  height: 2rem;
  color: inherit;
}

.label {
  margin-left: 0.75rem;
  transition: opacity 0.2s ease;
  white-space: nowrap;
  position: absolute;
  left: 2.5rem;
  top: 50%;
  transform: translateY(-50%);
}

.sidebar.collapsed .label {
  opacity: 0;
  pointer-events: none;
}

.tooltip {
  background-color: #1f2937;
  color: #ffffff;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  opacity: 1;
  visibility: visible;
}

.tooltip::before {
  content: "";
  position: absolute;
  left: -4px;
  top: 50%;
  transform: translateY(-50%);
  border: 4px solid transparent;
  border-right-color: var(--tooltip-background, #1f2937);
}

.userProfile {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.75rem;
  margin: 0 0.25rem 0.5rem 0.25rem;
  border-radius: 6px;
  text-decoration: none;
  color: #e9fff9;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  font-size: 0.875rem;
  font-weight: 500;
  overflow: hidden;
  border-top: 1px solid #1c1c1c;
  margin-top: auto;
  min-height: 3rem;
}

.userMenuPopup {
  position: fixed;
  bottom: 80px;
  left: 20px;
  background: #1c1c1c;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border: 1px solid #333;
  min-width: 200px;
  max-height: 80vh;
  overflow-y: auto;
}

.userMenuContent {
  padding: 1rem;
}

.userEmailHeader {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background-color: #2a2a2a;
  border-radius: 6px;
  margin-bottom: 0.25rem;
  gap: 0.75rem;
}

.userEmailIcon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.personIcon {
  width: 1.5rem;
  height: 1.5rem;
  color: #e9fff9;
  flex-shrink: 0;
}

.userEmail {
  font-size: 0.875rem;
  color: #e9fff9;
  font-weight: 500;
  word-break: break-all;
}

.userMenuItems {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.menuDivider {
  height: 1px;
  background-color: #333;
  margin: 0.5rem 0;
}

.profileImage {
  width: 2.5rem;
  height: 2.5rem;
  min-width: 2.5rem;
  min-height: 2.5rem;
  border-radius: 4px;
  background-color: var(--user-menu-profile-image-placeholder-background);
  color: var(--user-menu-profile-image-placeholder-color);
  border: 1px solid var(--user-menu-profile-image-placeholder-border);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.profileImage img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profileLabel {
  margin-left: 1rem;
  transition: opacity 0.2s ease;
  white-space: nowrap;
  position: absolute;
  left: 3rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
}

.profileName {
  font-weight: 600;
  color: white;
  font-size: 1rem;
}

.profileCompany {
  font-size: 0.75rem;
  color: #e9fff9;
}

/* Responsive design */
@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .sidebar:not(.collapsed) {
    transform: translateX(0);
  }

  .sidebar.collapsed {
    transform: translateX(-100%);
    width: 60px;
  }
}

/* Main content area with navigation and content side-by-side */
.mainContent {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.primaryNav {
  width: 70px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 0;
  flex-shrink: 0;
  border-right: 1px solid #333;
}

.navIcon {
  width: 100%;
  padding: 8px 0;
  background: transparent;
  cursor: pointer;
  color: #9ca3af;
  transition: color 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  /* Ensure icon and label are always on different lines */
  flex-wrap: nowrap;
  white-space: nowrap;
}

.navIcon:hover {
  color: #e5e7eb;
}

.navIconActive {
  color: #3b82f6;
  width: 100%;
  padding: 8px 0;
  background: transparent;
  cursor: pointer;
  transition: color 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.navIconSelected:not(.navIconActive) {
  color: #e5e7eb;
}

.navIconSelected:hover:not(.navIconActive) {
  color: #e5e7eb;
}

.navIconSvg {
  width: 20px;
  height: 20px;
}

.navIconWrapper {
  position: relative;
  display: inline-flex;
}

.betaBadge {
  position: absolute;
  top: -6px;
  right: -14px;
  font-size: 7px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: #3b82f6;
  color: #fff;
  padding: 1px 3px;
  border-radius: 3px;
  line-height: 1.2;
}

.loadMoreButton {
  width: 100%;
  padding: 12px 16px;
  margin: 8px 0;
  background: #374151;
  color: #e5e7eb;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.loadMoreButton:hover:not(:disabled) {
  background: #4b5563;
}

.loadMoreButton:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sectionTitleAction {
  display: flex;
  align-items: center;
  justify-content: center;
}

.inlineAddButton {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  min-width: 24px;
  height: 24px;
}

.inlineAddButton:hover {
  background: #2563eb;
}

.inlineAddIcon {
  width: 16px !important;
  height: 16px !important;
  font-size: 16px !important;
}

.navLabel {
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  display: block;
  width: 100%;
  line-height: 1.2;
  margin-top: 2px;
}

.secondaryContent {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: #1c1c1c;
}

.generateCombinedReport {
  padding: 10px 12px;
  border-bottom: 1px solid #333;
}

.generateCombinedReportButton {
  width: 100%;
  padding: 8px 12px;
  background: var(--green);
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.generateCombinedReportButton:hover {
  background: var(--light-green);
}

.sectionTitle {
  padding: 12px;
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #2a2a2a;
  border-bottom: 1px solid #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.contentList {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.insightsList {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
}

.insightItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  text-decoration: none;
  color: #e5e7eb;
  transition: background-color 0.2s ease;
  border: none;
  background: none;
  width: 100%;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
}

.insightItem:hover {
  background-color: #374151;
  color: #e5e7eb;
}

.currentRoute {
  background-color: #1e40af !important;
  border-left: 3px solid #3b82f6;
  font-weight: 600;
}

.currentRoute:hover {
  background-color: #1d4ed8 !important;
}

.itemContent {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.itemTitle {
  font-size: 12px;
  font-weight: 500;
  color: #e5e7eb;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.newItem .itemTitle {
  color: #9ca3af;
}

.itemDate {
  font-size: 11px;
  color: #9ca3af;
  white-space: nowrap;
  margin-left: 8px;
  flex-shrink: 0;
  flex-basis: auto;
}

.loadingIndicator {
  padding: 8px 12px;
  text-align: center;
  color: #9ca3af;
  font-size: 11px;
  font-style: italic;
  background: #2a2a2a;
  border-top: 1px solid #333;
}

.endIndicator {
  padding: 6px 12px;
  text-align: center;
  color: #9ca3af;
  font-size: 10px;
  font-style: italic;
  background: #2a2a2a;
  border-top: 1px solid #333;
}

.sectionSeparator {
  height: 1px;
  border-top: 2px dotted #4b5563;
  margin: 4px 12px;
}
.retryButton {
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  min-width: 50px;
  height: 24px;
}

.retryButton:hover:not(:disabled) {
  background: #b91c1c;
}

.retryButton:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.loadingSpinner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

/* Animation for smooth transitions */
.sidebar * {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

@media print {
  .sidebar {
    display: none !important;
  }
}
